import HhLogoImage from "../assets/images/logo.png";

export default function HhLogo() {
    return <img src={HhLogoImage} alt="Profi-log Health History" />;
}
